import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonImg,
  IonPage,
  IonToolbar,
} from '@ionic/react';
import {
  chevronDownOutline,
  chevronForwardOutline,
  helpCircleOutline,
  mailOutline,
} from 'ionicons/icons';
import { useState } from 'react';
import { useHistory } from 'react-router';

interface FAQ {
  question: string;
  answer: string;
}

const FAQS: FAQ[] = [
  {
    question: 'Can slot check predict future outcomes?',
    answer:
      'The short answer is no.  Slot machines are random and use random number generators to produce outcomes.  Slot Machines are games of chance.  Slot Check provides historical data on the recent past for players to make their own inferences.  Slot Check does not predict future outcomes.',
  },
  {
    question: 'Why Do Casinos Share Their Slot Data?',
    answer:
      'The answer is simple. It is good for business. Being transparent and sharing information with players is appreciated by players. It builds trust and loyalty.',
  },
  {
    question: 'Where Do We Get Our Slot Data?',
    answer:
      'Slot Check receives its data, by agreement, directly from the casino. Slot Check could not provide players with slot transparency if it was not for our affiliate casinos who provide us with a one-way feed of their slot data from their slot accounting system. To all our innovative casino affiliates, who have agreed to democratize their slot data, we applaud you for listening to your players and truly putting them first; and making a bold statement in the casino industry. A statement that is changing the way players think about and play slot machines, and the way casinos are thinking about customer loyalty, continuity, and how to make slot play more fun!',
  },
];

const SupportCenter: React.FC = () => {
  const history = useHistory();
  const [expandedIndex, setExpandedIndex] = useState<number | null>(0);

  const toggleFaq = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <IonPage className="support-center-page app-parent">
      <div className="slotcheck-header">
        <IonHeader className="small-header header-dark">
          <IonToolbar>
            <IonButton
              fill="clear"
              onClick={() => history.goBack()}
              className="icon-back"
              slot="start"
            >
              <IonImg src="assets/images/back-icon.svg" />
            </IonButton>
            <div className="logo header-title support-center-header-title">
              <IonIcon
                src="assets/icon/menuicons/support.svg"
                className="support-center-header-icon"
              />
              Support Center
            </div>
          </IonToolbar>
        </IonHeader>
      </div>

      <IonContent className="support-center-content">
        <p className="support-center-subtitle">Get help, and find answers to your questions</p>

        <div className="support-center-card">
          <div className="support-center-card__header">
            <div className="support-center-card__icon-wrap support-center-card__icon-wrap--email">
              <IonIcon icon={mailOutline} />
            </div>
            <div className="support-center-card__text">
              <div className="support-center-card__title">Email Support</div>
              <div className="support-center-card__subtitle">support@slotcheck.com</div>
            </div>
            <IonButton
              fill="outline"
              size="small"
              className="support-center-email-btn"
              href="mailto:support@slotcheck.com"
            >
              Send Email
            </IonButton>
          </div>
        </div>

        <div className="support-center-card">
          <div className="support-center-card__header">
            <div className="support-center-card__icon-wrap support-center-card__icon-wrap--faq">
              <IonIcon icon={helpCircleOutline} />
            </div>
            <div className="support-center-card__text">
              <div className="support-center-card__title">Frequently Asked Questions</div>
              <div className="support-center-card__subtitle">
                Find quick answers to common questions
              </div>
            </div>
          </div>

          <div className="support-center-faq-list">
            {FAQS.map((faq, index) => (
              <div
                key={index}
                className={`support-center-faq-item${
                  expandedIndex === index ? ' support-center-faq-item--expanded' : ''
                }`}
              >
                <button className="support-center-faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.question}</span>
                  <IonIcon
                    icon={expandedIndex === index ? chevronDownOutline : chevronForwardOutline}
                    className="support-center-faq-chevron"
                  />
                </button>
                {expandedIndex === index && (
                  <p className="support-center-faq-answer">{faq.answer}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default SupportCenter;
